import { useMediaQuery } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function Banner(props) {
  const sm = useMediaQuery("(max-width:600px)");
  const md = useMediaQuery("(max-width:1024px)");
  return (
    <section className="banner">
      <div className="shape right"></div>
      <div className="container big">
        <div
          className="row"
          style={{
            flexDirection: md && "column-reverse",
            padding: md && "25px 5%",
          }}
        >
          <div className="col-xl-6 col-md-12">
            <div className="banner__left">
              <div className="block-text">
                <h2 className="heading">
                  Money Tree{" "}
                  <span className="s1 arlo_tm_animation_text_word">Token</span>{" "}
                </h2>
                <p className="desc">
                  Choose silver as money. Protect your wealth.
                  <br />
                  Join a monetary system that gives back.
                </p>

                <Link to="/presale" className="action-btn">
                  <span>Start with Crypto</span>
                </Link>
              </div>

              {/* <div className="pay">
                <h6>We are Monteno NFT</h6>

                <div className="list">
                  <p>We accept:</p>

                  <ul>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-01"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-02"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-03"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-04"></span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-05">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                          <span className="path4"></span>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <span className="icon-logo-06"></span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
          <div className="col-xl-6 col-md-12">
            <div className="banner__right">
              <div
                className="image"
                style={{ display: "grid", placeItems: "center" }}
              >
                <img
                  src="/logo2.png"
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    maxWidth: sm ? 300 : 450,
                    maxHeight: sm ? 300 : 450,
                  }}
                />
              </div>
              {/* 
              <div className="price">
                <div className="icon">
                  <img src={img2} alt="cyfonii" />
                </div>
                <div className="content">
                  <p>Current Bid</p>
                  <h5>2.26 ETH</h5>
                </div>
              </div>

              <div className="owner">
                <div className="image">
                  <img src={img3} alt="cyfonii" />
                </div>
                <div className="content">
                  <h5>Leslie Alexander</h5>
                  <p>@leslie754</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
